import { useEffect, useMemo } from "react";
import ReactGA from "react-ga4";
import { useSearchParams } from "react-router-dom";

import EquipmentForm from "../../components/Forms/EquipmentForm/EquipmentForm.tsx";
import useSelectedEquipment from "../../utils/hooks/useSelectedEquipment.ts";

const EquipmentSelection = () => {
  const [searchParams] = useSearchParams();

  const { selectedEquipment } = useSelectedEquipment();

  const defaultValues = useMemo(() => {
    const equipmentData = localStorage.getItem("equipment");

    if (equipmentData) {
      return {
        equipment: JSON.parse(equipmentData),
      };
    }

    const eqIds = searchParams.get("e")?.split(",");
    if (eqIds) {
      return {
        equipment: eqIds.map((id) => ({
          id,
          count: 1,
          range: Number(searchParams.get("r") ?? 1),
          pricePerUnit: selectedEquipment?.find((el) => String(el.id) === id)?.pricePerUnit || 0,
        })),
      };
    }

    return {
      equipment: [],
    };
  }, [searchParams, selectedEquipment]);

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.href,
      title: "EQUIPMENT_SELECTION_PAGE",
    });
  }, []);

  return (
    <div>
      <EquipmentForm defaultValues={defaultValues} />
    </div>
  );
};

export default EquipmentSelection;
